import React from "react";
import { cn } from "./cn";

/**
 * Input de texto de la app. Un solo alto, un solo radio y un solo estado de
 * foco para formularios y modales (antes había tres estilos distintos).
 */
export interface TextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  containerClassName?: string;
}

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, hint, error, className, containerClassName, id, ...rest }, ref) => {
    const inputId = id || rest.name || undefined;
    const invalid = Boolean(error);

    return (
      <div className={cn("w-full text-left", containerClassName)}>
        {label ? (
          <label
            htmlFor={inputId}
            className="mb-1.5 block text-[13px] font-medium text-gray-900 dark:text-gray-200"
          >
            {label}
          </label>
        ) : null}

        <input
          ref={ref}
          id={inputId}
          aria-invalid={invalid || undefined}
          className={cn(
            "h-10 w-full rounded-field border bg-white px-3 text-sm text-gray-900",
            "placeholder:text-gray-600 transition-colors duration-150",
            "dark:bg-navy-900 dark:text-white dark:placeholder:text-gray-600",
            invalid
              ? "border-red-400 dark:border-red-500/60"
              : "border-gray-200 hover:border-gray-300 dark:border-white/10 dark:hover:border-white/20",
            className
          )}
          {...rest}
        />

        {error ? (
          <p className="mt-1.5 text-[12px] font-medium text-red-600 dark:text-red-400">
            {error}
          </p>
        ) : hint ? (
          <p className="mt-1.5 text-[12px] text-gray-700 dark:text-gray-400">
            {hint}
          </p>
        ) : null}
      </div>
    );
  }
);

TextField.displayName = "TextField";

export default TextField;
